import React from 'react'
import auth from '../auth'

import {
  Button,
  Input,
  List,
  NavLink
} from '../components'

import logo from '../assets/img/picsa_logo.png';

class LoginCreatePassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      password: '',
      resetResult: false,
      showError: false,
      errorFlags: []
    }
  }

  saveNewPassword = () => {
    if (this.isValidPassword()) {
      this.setState({ showError: false })
      auth.resetPassword(this.props.match.params.uid, this.props.match.params.token,
                         this.state.password, (result) => {
        if (result.reset) {
          let response = (
            <span>Reset successful. Please <NavLink to='/login'>login</NavLink> with your new password.</span>
          )
          this.setState({ resetResult: response})
        } else {
          let response = (
            <span>Reset failed. Please request a new reset email.</span>
          )
          this.setState({ resetResult: response})
        }
      })
    } else {
      this.setState({
        showError: true,
        password: ''
      })
    }
  }

  isValidPassword = () => {
    let fails = []
    if (this.state.password.length < 8) {
      fails.push(`be at least 8 characters long (yours is only ${this.state.password.length})`)
    }

    let atLeastOneLowerCaseRegex = new RegExp("(?=.*[a-z])")
    if (!atLeastOneLowerCaseRegex.test(this.state.password)) {
      fails.push("contain a lowercase letter")
    }

    let atLeastOneUpperCaseRegex = new RegExp("(?=.*[A-Z])")
    if (!atLeastOneUpperCaseRegex.test(this.state.password)) {
      fails.push("contain an uppercase letter")
    }

    let atLeastOneNumericRegex = new RegExp("(?=.*[0-9])")
    if (!atLeastOneNumericRegex.test(this.state.password)) {
      fails.push("contain a number")
    }

    this.setState({
      errorFlags: fails
    })

    if (fails.length > 0) {
      return false
    } else {
      return true
    }
  }

  render() {
    if (this.state.resetResult) {
      return (
        <div className="slds-grid slds-grid--vertical-align-center slds-grid--align-center">
          <section className="slds-m-bottom_xx-large">
            <br />
            <img src={logo} alt="Picsa Logo" style={{ height: '100px' }} />
            <hr />
            <div className="slds-text-heading_medium">
              { this.state.resetResult }
            </div>
          </section>
        </div>
      )
    }

    return (
      <div className="slds-grid slds-grid--vertical-align-center slds-grid--align-center">
        <section className="slds-m-bottom_xx-large">
          <br />
          <img src={logo} alt="Picsa Logo" style={{ height: '100px' }} />
          <hr />
          <div className="slds-text-heading_medium">
            Hi, lets create a secure password for your Picsa account.
          </div>
          <div className="slds-form slds-form--stacked slds-size_2-of-3">
            {this.state.showError
              ? <React.Fragment>
                  <Input
                    label="Create a password that is at least 8 characters long and contains at least one capital letter and one number"
                    hasError={true}
                    value={this.state.password}
                    onChange={(e) => this.setState({ password: e.target.value })}
                  />
                  <div className='slds-text-color_error slds-m-top_small slds-m-bottom_large'>
                    Please try again. Your password must meet these requirements:
                    <List
                      items={this.state.errorFlags}
                      type="dotted"
                    />
                  </div>
                </React.Fragment>
              : <Input
                  label="Create a password that is at least 8 characters long and contains at least one capital letter and one number"
                  value={this.state.password}
                  type="password"
                  onChange={(e) => this.setState({ password: e.target.value })}
                />
            }
            <div className="slds-form-element">
              <Button
                type="brand"
                className="u-text-caps"
                onClick={this.saveNewPassword}
                disabled={this.state.password.length === 0}
                minWidth={100}>
                Create
              </Button>
            </div>
            <div className="slds-form-element">
              <div className="slds-text-body--regular slds-p-bottom_small">
                Not a Picsa client? Please click <a href="https://picsa.com/contact">here</a>.
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default LoginCreatePassword



// WEBPACK FOOTER //
// ./src/containers/LoginCreatePassword.js